module.exports = __webpack_public_path__ + "9472f824b52acc761d1b8e7b3d6041c5.png";